import React, { useState, useRef } from 'react';
import './MainImage.less';
import { LoupeEffect } from '../Loupe/LoupeEffect';

export function MainImage({ src, alt, isLoupeActive, setLoupeActive }) {
  const [localLoupeActive, setLocalLoupeActive] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0, width: 0, height: 0 });
  const containerRef = useRef(null);

  const active = isLoupeActive !== undefined ? isLoupeActive : localLoupeActive;

  const updateCoords = (e) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      width: rect.width,
      height: rect.height,
    });
  };

  const handleMouseEnter = (e) => {
    updateCoords(e);
    setLocalLoupeActive(true);
    if (typeof setLoupeActive === 'function') {
      setLoupeActive(true);
    }
  };

  const handleMouseLeave = () => {
    setLocalLoupeActive(false);
    if (typeof setLoupeActive === 'function') {
      setLoupeActive(false);
    }
  };

  const handleMouseMove = (e) => {
    updateCoords(e);
  };

  return (
    <div
      ref={containerRef}
      className="main-image-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <img src={src} alt={alt} className="main-image__img" />
      {active && (
        <LoupeEffect
          src={src}
          x={mousePos.x}
          y={mousePos.y}
          width={mousePos.width}
          height={mousePos.height}
          zoom={2.5}
        />
      )}
    </div>
  );
}

export default MainImage;